import { changeLanguage } from '../store/user';
import { getAllObjectDescription } from '../store/salesforce';
import { createFetch } from '../utils';

export const changeAppLanguage = lang => ({
    type: changeLanguage,
    payload: lang,
});


export const getObjectDescription = (forceRefresh = false) => async (dispatch, getState) => {
    const { user } = getState();
    const response = await createFetch({
        path: `salesforce/all-sobject-describe?forceRefresh=${forceRefresh.toString()}`,
        method: 'GET',
        accessToken: user.accessToken,
    });
    dispatch({
        type: getAllObjectDescription,
        payload: response.records,
    });
};
export default null;
